export const removeTrailingNewlines = (str) => {
    return str.replace(/\n+$/, '');
}